import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for resetPasswordRequestInfo query
 */
export interface ResetPasswordRequestInfoVariables {
  requestId: string;
}

/**
 * Reset password request info structure
 */
export interface ResetPasswordRequestInfoData {
  createdDatetime: string;
  expired: boolean;
  email: string;
}

/**
 * Response structure for resetPasswordRequestInfo query
 */
export interface ResetPasswordRequestInfoResponse {
  resetPasswordRequestInfo: ResetPasswordRequestInfoData;
}

const resetPasswordRequestInfo: DocumentNode = gql`
  query ResetPasswordRequestInfo($requestId: UUID!) {
    resetPasswordRequestInfo(requestId: $requestId) {
      createdDatetime
      expired
      email
    }
  }
`;

export default resetPasswordRequestInfo;
